import * as actions from "@p81-common/shell-core-js/dist/redux/applicationsSettingsGet";

import {
  SOCKET_EVENT_APPLICATION_REMOVE_SUCCESS,
  SOCKET_EVENT_APPLICATION_UPDATE_SUCCESS,
  SOCKET_EVENT_APPLICATION_ADD_SUCCESS,
} from "../networksBeaconsGet/networksBeaconsGetActions";

export const addShouldUpdateFlag = (state, action) => ({
  ...state,
  shouldUpdateApplications: Date.now(),
});

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [actions.APPLICATIONS_SETTINGS_GET_REQUEST]: (state, action) => ({
    ...state,
    loading: true,
    loaded: false,
    error: null,
    data: state.data,
  }),
  [actions.APPLICATIONS_SETTINGS_GET_REQUEST_SUCCESS]: (state, action) => ({
    ...state,
    loading: false,
    loaded: true,
    error: null,
    data: action.data,
  }),
  [actions.APPLICATIONS_SETTINGS_GET_REQUEST_FAILURE]: (state, action) => ({
    ...state,
    loading: false,
    loaded: false,
    error: action.error,
    data: null,
  }),
  [actions.APPLICATIONS_SETTINGS_GET_RESET]: (state, action) => initialState,

  [SOCKET_EVENT_APPLICATION_REMOVE_SUCCESS]: addShouldUpdateFlag,
  [SOCKET_EVENT_APPLICATION_ADD_SUCCESS]: addShouldUpdateFlag,
  [SOCKET_EVENT_APPLICATION_UPDATE_SUCCESS]: addShouldUpdateFlag,
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  loaded: false,
  loading: false,
  error: null,
  data: null,
};

export default function applicationsSettingsGetReducer(
  state = initialState,
  action
) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
